import React, { useState, useContext, useMemo } from 'react';

const SMARTGoalsStateContext = React.createContext(null);
const SMARTGoalsDispatchContext = React.createContext(null);

export function SMARTGoalContextProvider(props) {
    const maxSteps = props.maxSteps;
    const [currentPage, setPage] = useState(1);

    // const contextValue = useMemo(() => ({
    //     maxSteps,
    //     maxPages: maxSteps + 2,
    //     currentPage: currentPage
    // }), [currentPage, maxSteps]);

    const dispatchContextValue = useMemo(() => ({
        setPage,
        maxSteps,
        maxPages: maxSteps + 2,
    }), [maxSteps]);

    //render
    return (
        <SMARTGoalsStateContext.Provider value={currentPage}>
            <SMARTGoalsDispatchContext.Provider value={dispatchContextValue}>
                {props.children}
            </SMARTGoalsDispatchContext.Provider>
        </SMARTGoalsStateContext.Provider>
    );
}

export function useSMARTGoalAppProps() {
    const { maxPages, maxSteps } = useContext(SMARTGoalsDispatchContext);

    return useMemo(() => ({ maxPages, maxSteps }), [maxPages, maxSteps]);
}

export function useSMARTGoalPageState() {
    const currentPage = useContext(SMARTGoalsStateContext);
    const { maxPages, maxSteps } = useSMARTGoalAppProps();

    return useMemo(() => ({
        currentPage, 
        maxPages, 
        maxSteps,
        showWelcome: currentPage === 1,
        showStep: currentPage > 1 && currentPage < maxPages,
        showReview: currentPage === maxPages
    }), [currentPage, maxPages, maxSteps]);
}

export function useSMARTGoalPageNavigation() {
    const { setPage, maxPages } = useContext(SMARTGoalsDispatchContext);

    const navigation = useMemo(() => ({
        nextPage: () => setPage((prev) => prev < maxPages ? ++prev : maxPages),
        prevPage: () => setPage((prev) => prev > 1 ? --prev : 1),
        setPage: (pageToSet) => setPage((prev) => pageToSet > 0 && pageToSet <= maxPages ? pageToSet : prev)
    }), [setPage, maxPages]);

    return navigation;
}